export default "__VITE_ASSET__BI3ZT8JW__"